import React from 'react'
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Aboutus() {
    const location = useLocation();

    useEffect(() => {
        const name = location.pathname;
        document.body.classNameName = name.substring(1) + "-body";
    }, [location]);
    return (
        <div className="about-us-page container">

            <div className="about-us  ">
                <div className="left-about-us ">
                    <img src="../assets/images/about-image.png" className="about-us-img" alt="" />
                </div>
                <div className="right-about-us">
                    <h1 className="about-us-h1">About Us</h1>
                    <div className="about-us-text">
                        <p className="about-us-p">ComTech DMCC is a trailblazer in delivering state-of-the-art Whitelabel
                            Technology Solutions, specifically crafted for sectors like banks, wealth management, portfolio
                            services, and family offices. Our robust solutions are designed to not only elevate our clients'
                            service portfolios but also to minimize operational losses, thereby driving significant
                            profitability. By seamlessly integrating our cutting-edge technologies, we empower businesses to
                            offer unmatched services, ensuring they remain leaders in their industries.</p>
                    </div>
                </div>
            </div>

            <div className="mission mt-5">
                <div className="left-mission mt-2">
                    <img src="../assets/images/mission-image.png" className="mission-img" alt="" />
                </div>
                <div className="right-mission">
                    <h1 className="mission-h1">Mission</h1>
                    <div className="mission-text">
                        <p className="mission-p">Our mission is to revolutionize the financial sector by equipping institutions
                            with transformative Whitelabel Solutions that enhance efficiency, optimize profitability, and
                            deliver superior service excellence.</p>
                    </div>
                </div>
            </div>

            <div className="vision mt-5">
                <div className="left-vision mt-2">
                    <img src="../assets/images/vision-image.png" className="vision-img" alt="" />
                </div>
                <div className="right-vision">
                    <h1 className="vision-h1">Vision</h1>
                    <div className="vision-text">
                        <p className="vision-p">Our vision is to lead the global Whitelabel Technology landscape, reshaping the
                            future of banking, wealth management, family offices, any more. We strive to empower these
                            sectors to unlock their full potential, driving innovation, reliability, and sustained growth
                            through our groundbreaking solutions.</p>
                    </div>
                </div>
            </div>


            <div className="container mb-3">
                <div className="row">
                    <div className="team">
                        <h1 className=" text-white">The Team</h1>
                    </div>

                    <div className="">
                        <div className="team-text">
                            <div className="team-box ">

                                <div className="team_thumb">
                                    <img src="assets/images/Jignesh.png" />
                                </div>

                                <div className="team_detail">
                                    <h2 className="fw-bold">Jignesh Ved <Link to="https://www.linkedin.com/in/jignesh-ved-b730984" target='blank'><img src="assets/images/linkend_icon.png" /></Link></h2>
                                    <div className='team-member'><span>Founder & CEO</span>  </div>
                                    <p>Jignesh Ved has a dynamic field experience of 27+ years in project management, consulting, and heading operations in leading firms. He is well experienced in strategic planning to achieve business goals by identifying and prioritizing development initiatives and setting timetables for evaluating, developing, and deploying all web-based services. </p>

                                    <p><a className='readmore' data-bs-toggle="modal" data-bs-target="#JigneshVed"> Read more </a></p>
                                </div>
                            </div>

  <div className="team-box">
                                <div className="team_thumb">
                                    <img src="assets/images/Ritika.png" />
                                </div>
                                <div className="team_detail">
                                    <h2 className="fw-bold">Ritika Bhardwaj <Link to="https://www.linkedin.com/in/ritika-bhardwaj-3826a413a" target='blank' ><img src="assets/images/linkend_icon.png" /></Link></h2>

                                    <div className='team-member'><span>Chief Operating Officer</span>  </div>
                                    <p>Ritika Bhardwaj leads the Operations and Human Resources departments at ComTech Gold, leveraging her extensive expertise to streamline business processes and cultivate a vibrant workplace culture. With a robust background in operational management and HR, Ritika is committed to enhancing efficiency and driving innovation within the company.</p>

                                    <p><a className='readmore' data-bs-toggle="modal" data-bs-target="#RitikaBhardwaj"> Read more </a></p>
                                </div>
                            </div>


                            <div className="team-box">
                                <div className="team_thumb">
                                    <img src="assets/images/LimSay.png" />
                                </div>
                                <div className="team_detail">
                                    <h2 className="fw-bold">Lim Say Cheong <Link to="http://www.linkedin.com/in/lim-say-cheong" target='blank' ><img src="assets/images/linkend_icon.png" /></Link></h2>

                                    <div className='team-member'><span>Chief Advisor, Digital Assets and Islamic Finance</span>  </div>
                                    <p>Lim Say Cheong is an accomplished business leader with over 25 years of experience in executive management and strategic development, with a strong focus on driving business growth and generating revenue. With a proven track record in business development, relationship building, and client acquisition, he has successfully spearheaded growth initiatives across diverse industries and countries. </p>

                                    <p><a className='readmore' data-bs-toggle="modal" data-bs-target="#LimSayCheong"> Read more </a></p>
                                </div>
                            </div>


                          

                            <div className="team-box">
                                <div className="team_thumb">
                                    <img src="assets/images/Gagan.png" />
                                </div>
                                <div className="team_detail">
                                    <h2 className="fw-bold">Gagandeep Singh <Link to="https://www.linkedin.com/in/gagandeep-sagar-singh" target='blank' ><img src="assets/images/linkend_icon.png" /></Link></h2>
                                    <div className='team-member'><span>Marketing Specialist</span> </div>
                                    <p>Gagandeep Singh is a seasoned marketing executive with over a decade of experience. Starting his career at Samsung Service Center, India, he quickly rose to become a Marketing Executive at Crypto & Properties LLC, Dubai. Gagandeep has demonstrated proficiency in using advanced digital marketing tools to enhance brand visibility and lead generation. His tenure at ComTech Gold saw significant marketing successes, including a 25% increase in lead generation and an 80% rise in brand visibility, attributed to his adept use of AI tools.</p>

                                    <p><a className='readmore' data-bs-toggle="modal" data-bs-target="#GagandeepSingh"> Read more </a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



            <div className="modal fade" id="JigneshVed" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="team2Label" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div className="modal-content team-text">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className="team_detail">
                                <h2 className="fw-bold mb-0">Jignesh Ved <Link to="https://www.linkedin.com/in/jignesh-ved-b730984" target='blank' className="ml-2"><img src="assets/images/linkend_icon.png" /></Link></h2>
                                <div className="team-member"><span >Founder</span></div>
                                <p className="mt-3">Jignesh Ved has a dynamic field experience of 27+ years in project management, consulting, and heading operations in leading firms. He is well experienced in strategic planning to achieve business goals by identifying and prioritizing development initiatives and setting timetables for evaluating, developing, and deploying all web-based services.</p>
                                <p className="mt-2">Jignesh is now leveraging his experience and connections at ComTech Gold in Ecosystem Development and Educating the community about XDC Network blockchain and tokenization technology benefits.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="LimSayCheong" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="team4Label" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div className="modal-content team-text">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className="team_detail">
                                <h2 className="fw-bold mb-0">Lim Say Cheong <Link to="http://www.linkedin.com/in/lim-say-cheong" target='blank' className="ml-2"><img src="assets/images/linkend_icon.png" /></Link></h2>
                                <div className="team-member"><span >Chief Advisor, Digital Assets and Islamic Finance</span> </div>
                                <p className="mt-3">Lim Say Cheong is an accomplished business leader with over 25 years of experience in executive management and strategic development, with a strong focus on driving business growth and generating revenue. </p>
                                <p className="mt-2">With a proven track record in business development, relationship building, and client acquisition, he has successfully spearheaded growth initiatives across diverse industries and countries. His expertise includes formulating strategic plans that align with organizational goals while identifying and capitalizing on market opportunities to maximize revenues.</p>
                                <p className="mt-2">As an Chief Advisor, Digital Assets and Islamic Finance at ComTech Gold, he is well-positioned to leverage his extensive experience to accelerate the company’s growth and aspirations.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="RitikaBhardwaj" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="team1Label" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div className="modal-content team-text">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className="team_detail">
                                <h2 className="fw-bold mb-0">Ritika Bhardwaj <Link to="https://www.linkedin.com/in/ritika-bhardwaj-3826a413a" target='blank' className="ml-2"><img src="assets/images/linkend_icon.png" /></Link></h2>
                                <div className="team-member"><span >Head of Operations & Human Resources</span> </div>
                                <p className="mt-3">Ritika Bhardwaj leads the Operations and Human Resources departments at ComTech Gold, leveraging her extensive expertise to streamline business processes and cultivate a vibrant workplace culture. With a robust background in operational management and HR, Ritika is committed to enhancing efficiency and driving innovation within the company.</p>
                                <p className="mt-2">Her dedication to excellence and focus on employee development have been instrumental in ComTech Gold's ongoing success and growth. Ritika's international experience in fast-paced, high-growth industries equips her with a deep understanding of Human Resource Development and Personnel Management Practices.</p>
                                <p className="mt-2">In her role, Ritika excels in managing diverse teams, including both permanent and outsourced employees, ensuring seamless communication and coordination across all organizational levels. Before joining ComTech Gold, she held significant HR positions at Tawreeq Holdings Limited and AL Noor Hospitals Group, where she honed her skills in human capital management and administration.</p>
                                <p className="mt-2">Ritika holds a Post Graduate Diploma in Business Management from LBSIMT, India.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="GagandeepSingh" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="team3Label" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                    <div className="modal-content team-text">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className="team_detail">
                                <h2 className="fw-bold mb-0">Gagandeep Singh <Link to="https://www.linkedin.com/in/gagandeep-sagar-singh" target='blank' className="ml-2"><img src="assets/images/linkend_icon.png" /></Link></h2>
                                <div className="team-member"><span >Marketing Specialist</span></div>
                                <p className="mt-3">Gagandeep Singh is a seasoned marketing executive with over a decade of experience. Starting his career at Samsung Service Center, India, he quickly rose to become a Marketing Executive at Crypto & Properties LLC, Dubai. Gagandeep has demonstrated proficiency in using advanced digital marketing tools to enhance brand visibility and lead generation. His tenure at ComTech Gold saw significant marketing successes, including a 25% increase in lead generation and an 80% rise in brand visibility, attributed to his adept use of AI tools.</p>
                                <p className="mt-2">Before ComTech, Gagandeep served in various roles at Alrais Enterprises Group LLC, Hotel Empire Corporate Office, India, and as a Social Media Consultant for prestigious establishments in Dubai. He holds an Economics degree from Chaudhary Charan Singh University, India, and certifications in Content and Digital Marketing. Currently, at ComTech Gold, Gagandeep is leveraging his vast experience to forge strategic partnerships and implement operational efficiencies, aiming to revolutionize the marketing landscape.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </div>

    )
}

export default Aboutus
